import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ODS_PROVIDER_NAME_ZAVA } from '../../ods/ODS_PROVIDER_NAME'

export const productAccessorHasZavaOdsPartner = (
  product: PimProductV11,
): boolean => {
  return product.ods_partners?.includes(ODS_PROVIDER_NAME_ZAVA) ?? false
}
